// extracted by mini-css-extract-plugin
export default {"main":"PreviewPage_main__bi5bu","header":"PreviewPage_header__dDe99","body":"PreviewPage_body__XM+L-","mobile":"PreviewPage_mobile__GB9q4"};